"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ExtendedArray_1 = __importDefault(require("../tools/ExtendedArray"));
var boss_1 = __importDefault(require("./boss"));
/**
 * Spider - Tsuchigumo
 * Dragon - Tatsu
 * Fish - Namazu
 */
var Bosses = /** @class */ (function (_super) {
    __extends(Bosses, _super);
    function Bosses() {
        var _this = _super.call(this) || this;
        var bosses = [
            new boss_1.default({
                name: 'Namazu',
                level: 12,
                type: "fish",
                hp: 123
            }),
            new boss_1.default({
                name: 'Tsuchigumo',
                level: 1,
                type: "spider",
                hp: 12
            }),
            new boss_1.default({
                name: 'Tatsu',
                level: 3,
                type: "dragon",
                hp: 12
            }),
        ];
        bosses[0].dead = true;
        _this.push.apply(_this, __spread(bosses));
        return _this;
    }
    Bosses.hydrate = function (obj) {
        var bosses = Object.assign(new Bosses(), obj);
        return bosses;
    };
    return Bosses;
}(ExtendedArray_1.default));
exports.default = Bosses;
